import { tap } from 'rxjs/operators';
import { Statuses } from 'src/app/models/kn-br-quote.model';
import { Observable, Subscription } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'kn-br-quote-reject-comments',
    templateUrl: './kn-br-quote-reject-comments.component.html',
    imports: [NgSelectComponent, ReactiveFormsModule, FormsModule, AsyncPipe, TranslatePipe]
})
export class KnBrQuoteRejectCommentsComponent implements OnInit, OnDestroy {
  comment: string;
  reasons$: Observable<Statuses[]>;
  reason;
  quoteStatus: string;
  showReasons = false;
  isReasonsLoading = false;
  subscription = new Subscription();
  isCart: boolean;
  constructor(private knBrCommonService: KnBrCommonService, protected modalService: NgbModal) {}

  ngOnInit(): void {
    if (this.quoteStatus === 'SELLER_REJECTED' || this.quoteStatus === 'CART_SELLER_REJECTED') {
      this.showReasons = true;
    }
    if (this.isCart) {
      this.knBrCommonService.getDraftOrderRejectReasonList();
      this.reasons$ = this.knBrCommonService.loadDraftOrderRejectReasonList$();
    } else {
      this.knBrCommonService.getQuoteRejectReasonList();
      this.reasons$ = this.knBrCommonService.loadQuoteRejectReasonList$();
    }
    this.subscription.add(
      this.reasons$.subscribe((res) => {
        if (res && res.length > 0) {
          this.reason = res[0].Key;
          this.isReasonsLoading = false;
        }
      })
    );
  }

  saveComment() {
    if (this.showReasons) {
      const req = {
        reason: this.reason,
        comment: this.comment,
      };
      this.modalService.dismissAll(req);
    } else {
      this.modalService.dismissAll(this.comment);
    }
  }
  dismissModal(reason?: any): void {
    this.modalService.dismissAll(reason);
  }

  ngOnDestroy() {
    this.showReasons = false;
  }
}
